import { Draft } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

export const clearRedeemVoucher = (state: Draft<IPaymentState>) => {
  state.redeemVoucher = null;
  state.updatedAt = Date.now();
};
